export const FOLDER_COLOR_KEYS = [
  'red',
  'orange',
  'yellow',
  'green',
  'blue',
  'purple',
] as const;

export type FolderColorKey = (typeof FOLDER_COLOR_KEYS)[number];

/** Canonical values stored in FolderAsset.userProvidedColor. */
export const FOLDER_COLOR_HEX = {
  red: '#ff6471',
  orange: '#ff6f03',
  yellow: '#eeb400',
  green: '#00c958',
  blue: '#729fff',
  purple: '#aa8aff',
} as const satisfies Record<FolderColorKey, string>;
